/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createContractEligibilityFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ContractEligibility, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/eligibility
 */
export interface EligibilityRequestBuilder extends BaseRequestBuilder<EligibilityRequestBuilder> {
    /**
     * GetContractEligibility
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ContractEligibility>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ContractEligibility | undefined>;
    /**
     * GetContractEligibility
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const EligibilityRequestBuilderUriTemplate = "{+baseurl}/contracts/eligibility";
/**
 * Metadata for all the requests in the request builder.
 */
export const EligibilityRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: EligibilityRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createContractEligibilityFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
